module.exports = __webpack_public_path__ + "img/egc.07abc8e9.png";